import { render } from "./Summary.vue?vue&type=template&id=012c2275"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
script.render = render

export default script